import PropTypes from 'prop-types';
import React from 'react';

require('./style.scss');

const Form = props =>
  <form
    className="form"
    onSubmit={props.onSubmit}
  >
    {props.children}
  </form>;

Form.propTypes = {
  children: PropTypes.node,
  onSubmit: PropTypes.func,
};

module.exports = Form;



// WEBPACK FOOTER //
// ./app/components/common/form/Form.jsx